import { t } from '@lingui/core/macro';
import { PurchaseOrderUserDTO } from '@luminovo/api-contracts';
import { isPresent } from '@luminovo/commons';
import { FieldSelect, FieldSelectProps } from '@luminovo/design-system';

export interface FieldUserProps extends FieldSelectProps<PurchaseOrderUserDTO> {
    onValueChange?: (value: PurchaseOrderUserDTO | null) => void;
}

export function FieldUser({ onChange, onValueChange, ...props }: FieldUserProps): JSX.Element {
    return (
        <FieldSelect
            getOptionLabel={(user) =>
                isPresent(user) ? `${user.first_name} ${user.last_name} (${user.email})` : t`No recipient selected`
            }
            isOptionEqualToValue={(opt, value) => opt.id === value.id}
            disableClearable
            onChange={(value) => {
                onChange(value);
                onValueChange?.(value);
            }}
            {...props}
        />
    );
}
